// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ReadyPlansListQueryVariables = Types.Exact<{
  development?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
}>;


export type ReadyPlansListQuery = { __typename?: 'Query', readyPlans: Array<{ __typename?: 'ReadyPlan', id: string, name: string, code?: string | null | undefined, displayCode?: string | null | undefined, activeOptionsCount: number, type?: { __typename?: 'ReadyPlanTypeDetail', code: Types.ReadyPlanType, name: string } | null | undefined, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus, name: string }, development?: { __typename?: 'Development', id: string } | null | undefined }> };

export type ReadyPlanDetailFragment = { __typename?: 'ReadyPlan', id: string, name: string, code?: string | null | undefined, displayCode?: string | null | undefined, activeOptionsCount: number, type?: { __typename?: 'ReadyPlanTypeDetail', code: Types.ReadyPlanType, name: string } | null | undefined, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus, name: string }, development?: { __typename?: 'Development', id: string } | null | undefined };

export const ReadyPlanDetailFragmentDoc = gql`
    fragment ReadyPlanDetail on ReadyPlan {
  id
  name
  code
  displayCode
  activeOptionsCount
  type {
    code
    name
  }
  status {
    code
    name
  }
  development {
    id
  }
}
    `;
export const ReadyPlansListDocument = gql`
    query ReadyPlansList($development: [ID!]) {
  readyPlans(filter: {development: $development}) {
    ...ReadyPlanDetail
  }
}
    ${ReadyPlanDetailFragmentDoc}`;

/**
 * __useReadyPlansListQuery__
 *
 * To run a query within a React component, call `useReadyPlansListQuery` and pass it any options that fit your needs.
 * When your component renders, `useReadyPlansListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReadyPlansListQuery({
 *   variables: {
 *      development: // value for 'development'
 *   },
 * });
 */
export function useReadyPlansListQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReadyPlansListQuery, ReadyPlansListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReadyPlansListQuery, ReadyPlansListQueryVariables>(ReadyPlansListDocument, options);
      }
export function useReadyPlansListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReadyPlansListQuery, ReadyPlansListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReadyPlansListQuery, ReadyPlansListQueryVariables>(ReadyPlansListDocument, options);
        }
// @ts-ignore
export function useReadyPlansListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ReadyPlansListQuery, ReadyPlansListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReadyPlansListQuery, ReadyPlansListQueryVariables>;
export function useReadyPlansListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReadyPlansListQuery, ReadyPlansListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReadyPlansListQuery | undefined, ReadyPlansListQueryVariables>;
export function useReadyPlansListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReadyPlansListQuery, ReadyPlansListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReadyPlansListQuery, ReadyPlansListQueryVariables>(ReadyPlansListDocument, options);
        }
export type ReadyPlansListQueryHookResult = ReturnType<typeof useReadyPlansListQuery>;
export type ReadyPlansListLazyQueryHookResult = ReturnType<typeof useReadyPlansListLazyQuery>;
export type ReadyPlansListSuspenseQueryHookResult = ReturnType<typeof useReadyPlansListSuspenseQuery>;
export type ReadyPlansListQueryResult = ApolloReactCommon.QueryResult<ReadyPlansListQuery, ReadyPlansListQueryVariables>;